<ng-template #managingUser>Submitted by {{ userRequest.ManagingUserDisplayName }}</ng-template>
<ng-template #bothUsers>
    {{ userRequest.ManagingUserDisplayName }} submitted on behalf of {{ userRequest.DisplayName }}
</ng-template>
<i *ngIf="userRequest?.ManagingUserID != userRequest?.UserID" 
    class="fas fa-user"
    [ngClass]="innerClass" 
    aria-hidden="true"
    [ngbPopover]="config.popoverType === 'managingUser' ? managingUser : bothUsers" 
    popoverTitle="Managing User"
    triggers="mouseenter:mouseleave"></i>
